import { State } from '../../redux/rootReducer'

export const getState = (state: State) => state.payments

export const getBalance = (state: State) => getState(state).balance
export const getBalanceAmount = (state: State) => getBalance(state).amount ?? 0
